import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';

import ModalForm from './Form/Modal';

import { useContext } from './Context';

export default function Table() {
  const { dispatch, actions, state } = useContext();

  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('active');

  const conditionalRowStyles = [
    {
      when: (row) => row.attributes.deleted_at !== '',
      style: {
        backgroundColor: '#ccc',
        color: 'white',
      },
    },
  ];

  useEffect(() => {
    actions.load(dispatch, { affiliateId: state.affiliateId });
  }, []);

  return (
    <>
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        status={status}
        setStatus={setStatus}
      />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns(state.affiliateId)}
          data={data(state.prospects, keyword, status) || []}
          noDataComponent={(
            <div className="mt20">
              {state.prospects == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
      {state.currentProspect !== null && <ModalForm />}
    </>
  );
}
